import Link from 'next/link'
import cx from 'classnames'
import { Image } from '@/components/v2/atoms/image/image'
import { ROUTES, SLIDER_CLASS_NAME } from '@/constants'
import type { ShopMegaMenuFeatured } from '@/types/api/shop-mega-menu'
import s from './nav-shop-mega-menu.module.scss'

type Props = {
  collection: ShopMegaMenuFeatured
  onNavigate: () => void
}

// A featured collection card in the desktop FEATURED slider: cover, title, then
// the SHOP eyebrow. Deliberately not the `Card` atom — every one of its Article
// behaviours (article bookmark, "Read more" hover, role="article",
// `category / date` eyebrow) is wrong for a collection, and suppressing four of
// them in a site-wide atom costs more than the card itself.
export const ShopMegaMenuCard = ({ collection, onNavigate }: Props) => (
  <Link
    href={ROUTES.SHOP.COLLECTION(collection.slug)}
    className={cx(s.card, SLIDER_CLASS_NAME)}
    onClick={onNavigate}
  >
    <span className={s.cardMedia}>
      {collection.imageUrl && (
        <Image
          src={collection.imageUrl}
          alt=""
          width={330}
          height={283}
          className={s.cardImage}
        />
      )}
    </span>
    <span className={s.cardTitle}>{collection.title}</span>
    <span className={s.cardEyebrow}>Shop</span>
  </Link>
)
